module.exports = __webpack_public_path__ + "img/bc-sign-in-papyrus-blue.b9311a78.jpg";